$(document).ready(function () {
    const isTouchLike = window.matchMedia('(hover: none), (pointer: coarse)').matches;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    const shadow = document.createElement('div');
    const offsetX = 70;
    const offsetY = 55;
    let pointerX = window.innerWidth / 2;
    let pointerY = window.innerHeight / 2;
    let frameId = null;
    let scrollFrameId = null;
    let shadowHost = null;

    shadow.className = 'mouseover-shadow';
    shadow.setAttribute('aria-hidden', 'true');
    document.body.appendChild(shadow);

    const updateTheme = function (target) {
        const themedContainer = target.closest('[data-bs-theme]');
        const header = target.closest('header[data-bs-theme]');
        const submenu = target.closest('.submenu-new-template');
        const footer = target.closest('.footer-home, .footer-bottom');
        const nextShadowHost = header || footer;
        const heroVideo = target.closest(
            '.hero-video-autoplay, .banner-template .banner-video-content'
        );
        const isDarkTheme = Boolean(submenu || footer) || (
            themedContainer &&
            themedContainer.getAttribute('data-bs-theme') === 'dark'
        );

        if (nextShadowHost !== shadowHost) {
            if (shadowHost) {
                shadowHost.classList.remove('has-mouseover-shadow');
            }

            if (nextShadowHost) {
                nextShadowHost.appendChild(shadow);
                nextShadowHost.classList.add('has-mouseover-shadow');
                shadow.classList.add('is-contained');
            } else {
                document.body.appendChild(shadow);
                shadow.classList.remove('is-contained');
            }

            shadowHost = nextShadowHost;
        }

        shadow.classList.toggle('is-light', !isDarkTheme);
        shadow.classList.toggle('is-over-hero-video', Boolean(heroVideo));
    };

    const updatePosition = function () {
        const shadowX = pointerX + (isTouchLike ? 0 : offsetX);
        const shadowY = pointerY + (isTouchLike ? 0 : offsetY);

        shadow.style.left = shadowX + 'px';
        shadow.style.top = shadowY + 'px';
        frameId = null;
    };

    const updateTouchShadow = function () {
        pointerX = window.innerWidth / 2;
        pointerY = window.innerHeight / 2;

        const target = document.elementFromPoint(pointerX, pointerY);

        if (target) {
            updateTheme(target);
        }

        shadow.classList.add('is-visible');
        updatePosition();
    };

    if (isTouchLike) {
        updateTouchShadow();

        window.addEventListener('scroll', function () {
            if (scrollFrameId) {
                return;
            }

            scrollFrameId = window.requestAnimationFrame(function () {
                updateTouchShadow();
                scrollFrameId = null;
            });
        }, { passive: true });

        window.addEventListener('resize', updateTouchShadow);

        return;
    }

    document.addEventListener('mousemove', function (event) {
        pointerX = event.clientX;
        pointerY = event.clientY;
        updateTheme(event.target);
        shadow.classList.add('is-visible');

        if (!frameId) {
            frameId = window.requestAnimationFrame(updatePosition);
        }
    });

    window.addEventListener('scroll', function () {
        if (scrollFrameId) {
            return;
        }

        scrollFrameId = window.requestAnimationFrame(function () {
            const target = document.elementFromPoint(pointerX, pointerY);

            if (target) {
                updateTheme(target);
            }

            scrollFrameId = null;
        });
    }, { passive: true });

    document.documentElement.addEventListener('mouseleave', function () {
        shadow.classList.remove('is-visible');
    });
});



// WEBPACK FOOTER //
// ./resources/js/modules/mouseover-shadow.js